module.exports = __webpack_public_path__ + "static/6-96808e3c70a20136adcbb57766fde020.jpg";